import React from 'react'
import { Grid, Typography } from '@mui/material'
import { TextInput } from '@labrav/react-components'
import { FormikProps } from 'formik'

import { Product } from '../../../modules/productsListing/types'
import { FormValues } from './AddListingModal'
import { useStyles } from './AddListingFormFields.style'

export type AddListingFormFieldsProps = {
  modalProductData: Product
  formik: FormikProps<FormValues>
}

export default function AddListingFormFields({
  formik,
}: AddListingFormFieldsProps) {
  const { classes } = useStyles()
  return (
    <div data-testid="add-listing-modal" className={classes.textField}>
      <Typography variant="body2" className={classes.paragraph}>
        Please enter the listing details below.
      </Typography>
      <Grid container spacing={5}>
        <Grid
          size={{
            xs: 12,
            sm: 8,
            md: 4,
            lg: 4,
            xl: 3,
          }}
        >
          <TextInput
            isRequired
            placeHolder=""
            isReadOnly={false}
            keyName="productCode"
            title="Product Code"
            value={formik.values.productCode}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            isError={
              !!(formik.touched.productCode && formik.errors.productCode)
            }
            errorText={
              (formik.touched.productCode && formik.errors.productCode) || ' '
            }
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 8,
            md: 4,
            lg: 4,
            xl: 3,
          }}
        >
          <TextInput
            isRequired
            placeHolder=""
            isReadOnly={false}
            keyName="productId"
            title="Product ID"
            value={formik.values.productId}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            isError={!!(formik.touched.productId && formik.errors.productId)}
            errorText={
              (formik.touched.productId && formik.errors.productId) || ' '
            }
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 8,
            md: 4,
            lg: 4,
            xl: 3,
          }}
        >
          <TextInput
            isRequired
            placeHolder=""
            isReadOnly={false}
            keyName="productUrl"
            title="Product URL"
            value={formik.values.productUrl}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            isError={!!(formik.touched.productUrl && formik.errors.productUrl)}
            errorText={
              (formik.touched.productUrl && formik.errors.productUrl) || ' '
            }
          />
        </Grid>
      </Grid>
    </div>
  )
}
